import { object, string } from 'yup'

export type TForgotPasswordValues = {
  email: string
}

export const initialForgotPasswordValues: TForgotPasswordValues = {
  email: '',
}

export const forgotPasswordValidationSchema = object().shape({
  email: string().email('Please enter a valid email address.').required('Required.').trim(),
})
